import script from "./CreateEditNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateEditNotice.vue?vue&type=script&setup=true&lang=ts"

import "./CreateEditNotice.vue?vue&type=style&index=0&id=530ed24e&lang=css"

const __exports__ = script;

export default __exports__